import { render, staticRenderFns } from "./WinePage.vue?vue&type=template&id=8f4b8a06&scoped=true"
import script from "./WinePage.vue?vue&type=script&lang=js"
export * from "./WinePage.vue?vue&type=script&lang=js"
import style0 from "./WinePage.vue?vue&type=style&index=0&id=8f4b8a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4b8a06",
  null
  
)

export default component.exports